import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import SaveButton from "cards/components/SaveButton";
import { toggleStorySave } from "users/actions/userSettings";

class ConnectedSaveButton extends React.Component {
  constructor() {
    super();
    this.state = { saved: false };
    this.toggleStorySave = this._toggleStorySave.bind(this);
  }

  static getDerivedStateFromProps(props) {
    return { saved: props.savedStories.includes(props.id) };
  }

  _toggleStorySave() {
    this.props.toggleStorySave(this.props.id, this.state.saved);
  }

  render() {
    return (
      <SaveButton saved={this.state.saved} onClick={this.toggleStorySave} />
    );
  }
}

ConnectedSaveButton.propTypes = {
  savedStories: PropTypes.arrayOf(PropTypes.string),
  toggleStorySave: PropTypes.func.isRequired,
  id: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    savedStories: state.userSettings.data.profileInfo.savedStoryIds,
  };
};

const mapDispatchToProps = {
  toggleStorySave,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSaveButton);
